// extracted by mini-css-extract-plugin
export default {"wrapper":"DataTablePagination_wrapper__eLbBT","page-size-selector":"DataTablePagination_page-size-selector__fBECS","buttons-wrapper":"DataTablePagination_buttons-wrapper__tr1jV"};